import { TipoOptions } from "@app/api/api";
import { AContratarViewResult } from "@app/api/crf/crfAContratar";
import { ADistribuirViewResult, ExecutadoMesAnoADistribuir } from "@app/api/crf/crfADistribuir";
import { CrfEsin204ViewModel } from "@app/api/crf/crfEsin204ContaResultado";
import { ICrfTipoDistribuicaoForcast } from "@app/api/crf/crfTipoDistribuicaoForcast";
import { CrfRegistroEsin204Importacao } from "@app/api/crf/CrtRegistroEsin204";
import { Historico } from "@app/api/parametro";
import { Tipo } from "@app/api/status";
import { ColumnProps } from "@digital/ui";
import { atom } from "recoil";



export const crfEsin204ViewModelResult = atom<CrfEsin204ViewModel>({
    key: 'crfEsin204ViewModelResult',
    default: {} as CrfEsin204ViewModel
});


export const crfEsin204ipo = atom<Array<TipoOptions>>({
    key: 'crfEsin204ipo',
    default: Array<TipoOptions>()
});

export const listCrfRegistroEsin204Importacao = atom<Array<CrfRegistroEsin204Importacao>>({
    key: 'listCrfRegistroEsin204Importacao',
    default: Array<CrfRegistroEsin204Importacao>()
})

export const listCrfRegistroEsin204Fechamento = atom<Array<CrfRegistroEsin204Importacao>>({
    key: 'listCrfRegistroEsin204Fechamento',
    default: Array<CrfRegistroEsin204Importacao>()
})

export const listHistoricoExecucaorotina = atom<Array<Historico>>({
    key: 'listHistoricoExecucaorotina',
    default: Array<Historico>()
})

export const aContratarProjetoResult = atom<AContratarViewResult>({
    key: 'aContratarProjetoResult',
    default: {} as AContratarViewResult
});

export const aDistribuirProjetoResult = atom<ADistribuirViewResult>({
    key: 'aDistribuirProjetoResult',
    default: {} as ADistribuirViewResult
});

export const executadoMesAnoADistribuir = atom<Array<ExecutadoMesAnoADistribuir>>({
    key: 'executadoMesAnoADistribuir',
    default: Array<ExecutadoMesAnoADistribuir>()
});

export const collunsADistribuir = atom<Array<ColumnProps<any>>>({
    key: 'collunsADistribuir',
    default: Array<ColumnProps<any>>()
});

export const listCrfTipoDistribuicaoForcast = atom<Array<TipoOptions>>({
    key: 'listCrfTipoDistribuicaoForcast',
    default: Array<TipoOptions>()
});

export const listICrfTipoDistribuicaoForcast = atom<Array<ICrfTipoDistribuicaoForcast>>({
    key: 'listICrfTipoDistribuicaoForcast',
    default: Array<ICrfTipoDistribuicaoForcast>()
});